import { atom } from "jotai";

export const currOrgUnameAtom = atom<string | null>(null);